import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import {
  faChalkboardUser,
  faCheckCircle,
  faCircleExclamation,
  faSpinner, faUserPen,
  faUserPlus,
  faUserXmark
} from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { ManagementUser } from '../../core/models/management-user.model';
import { SessionStorageService } from '../../core/services/session-storage.service';
import { UsersService } from '../../core/services/users.service';
import { DisplayUserRole } from '../../core/pipes/display-user-role.pipe';

@Component({
  selector: 'wf-users-list',
  standalone: true,
  imports: [
    SharedModule,
    FontAwesomeModule,
    NgClass,
    DisplayUserRole,
  ],
  templateUrl: './users-list.component.html',
  styleUrl: './users-list.component.css'
})
export class UsersListComponent implements OnInit {
  currentUser: ManagementUser | null = null ;
  users: ManagementUser[] = [] ;
  selectedUsers: Set<number> = new Set<number>() ;

  isDeleting: boolean = false ;
  usersSelected: boolean = false ;

  message: string = '' ;
  messageTitle: string = '' ;
  messageStatus: string = '' ;

  loadingIcon = faSpinner ;
  successIcon = faCheckCircle ;
  errorIcon = faCircleExclamation ;
  schoolUsersIcon = faChalkboardUser ;
  addSchoolUserIcon = faUserPlus ;
  editSchoolUserIcon = faUserPen;
  deleteSchoolUserIcon = faUserXmark ;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sessionService: SessionStorageService,
    private usersService: UsersService,
  ) { }

  ngOnInit(): void {
    this.currentUser = this.sessionService.getUserData() ;
    this.users = this.route.snapshot.data['users'] ;
  }

  addSchoolUser() {
    this.router.navigateByUrl('user/add') ;
  }

  archiveSchoolUsers() {
    this.isDeleting = true ;

    const usersToArchive = this.users.filter((user) => this.selectedUsers.has(user.userID)) ;
    if (!usersToArchive.length)
    {
      this.isDeleting = false ;
      return ;
    }

    this.usersService.archiveSchoolUsers(usersToArchive).subscribe({
      next: () => {
        this.messageStatus = 'success';
        this.messageTitle = 'Account(s) Archived Successfully';
        this.message = 'Your School User Accounts were successfully archived.';

        this.isDeleting = false;
        this.usersSelected = false ;
        this.selectedUsers.clear() ;
        this.usersService.getSchoolUsers().subscribe({
          next: (data) => {
            this.users = data ;
          }
        })
      },
      error: (error) => {
        this.messageStatus = 'error';
        this.messageTitle = 'Account(s) Not Archived';
        this.message = 'An error occurred while trying to archive your School User Accounts: ';
        if (error.error && error.error.message) {
          this.message += `<br>${error.error.message}`;
        }

        this.isDeleting= false;
      }
    })
  }

  editUser(userId: number) {
    const user = this.users.find((user) => user.userID === userId) ;
    if (user)
    {
      this.router.navigateByUrl(`user/edit/${userId}`, { state: { user }}) ;
    }
  }

  userToggled(e: any) {
    if (e.target.checked)
    {
      this.selectedUsers.add(parseInt(e.target.value)) ;
    }
    else
    {
      this.selectedUsers.delete(parseInt(e.target.value)) ;
    }
    this.usersSelected = this.selectedUsers.size > 0 ;
  }
}
